<template>
  <v-container
      id="chat-list"
      fluid
      tag="section"
      pt-0
  >
    <v-row justify="center">
      <v-col
          cols="12"
          md="4"
      >
        <chat-list-panel></chat-list-panel>
      </v-col>
      <v-col
          cols="12"
          md="8"
      >
        <chat-panel></chat-panel>
      </v-col>
    </v-row>
    <chat-multi-media-show></chat-multi-media-show>
  </v-container>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'ChatList',
  components: {
    ChatListPanel: () => import('@/view/dashboard/components/chat/ChatListPanel'),
    ChatPanel: () => import('@/view/dashboard/components/chat/ChatPanel'),
    ChatMultiMediaShow: () => import('@/view/dashboard/components/chat/ChatMultiMediaShow'),
  },
  created() {
    this.$store.dispatch('cleanChatList').then(() => {
      this.$store.dispatch('retrieveAllChatList', {offset: 0, limit: 100})
    })
  }
  ,
  computed: {
    ...
        mapState(['barColor', 'barImage']),
  }
  ,
  beforeRouteLeave: function (to, from, next) {
    this.$store.dispatch('destroyHub').then(() => {
      next();
    })
  }
}
</script>
